import { 
  BarChart3, 
  Brain,
  TrendingUp,
  ClipboardList,
  Timer,
  UserCheck,
  Bell,
  Users,
  Target
} from "lucide-react";
import type { MenuItem } from "../types";

export const analyticsSections: MenuItem = {
  title: "التحليل",
  href: "#",
  icon: TrendingUp,
  color: "from-indigo-500 to-indigo-600",
  permission: "عرض التحليلات",
  subItems: [
    {
      title: "اتجاهات المبيعات والتنبؤات",
      href: "/sales-trends",
      icon: TrendingUp,
      color: "from-emerald-500 to-teal-600",
      permission: "عرض التحليلات",
    },
    {
      title: "مراقبة الأداء الذكي",
      href: "/smart-performance",
      icon: BarChart3,
      color: "from-blue-500 to-purple-600",
      permission: "عرض تحليلات الأداء",
    },
    {
      title: "تحليلات الذكاء الاصطناعي",
      href: "/ai-analytics",
      icon: Brain,
      color: "from-purple-500 to-purple-600",
      permission: "عرض تحليلات الذكاء الاصطناعي",
    },
    {
      title: "تقارير المتابعات",
      href: "/followup-reports",
      icon: ClipboardList,
      color: "from-green-500 to-emerald-600",
      permission: "عرض التحليلات",
    },
    {
      title: "تحليلات المهام",
      href: "/task-analytics",
      icon: BarChart3,
      color: "from-orange-500 to-amber-600",
      permission: "عرض التحليلات",
    },
    {
      title: "تقارير تتبع الوقت",
      href: "/time-tracking-reports",
      icon: Timer,
      color: "from-cyan-500 to-blue-600",
      permission: "عرض التحليلات",
    },
    {
      title: "أداء الموظفين",
      href: "/employee-performance",
      icon: UserCheck,
      color: "from-purple-500 to-pink-600",
      permission: "عرض التحليلات",
    },
    {
      title: "مقارنة الفرق",
      href: "/team-performance",
      icon: Users,
      color: "from-teal-500 to-cyan-600",
      permission: "عرض التحليلات",
    },
    {
      title: "إدارة الأهداف والحوافز",
      href: "/performance-goals",
      icon: Target,
      color: "from-amber-500 to-orange-600",
      permission: "إدارة النظام",
    }
  ]
};